import {Injectable} from "@angular/core";
import {GlobalProvider} from "../global/global";
import {App} from "ionic-angular";
import {HttpClient} from "@angular/common/http";
import {HomePage} from "../../pages/home/home";
import {DatabaseModel} from "../../models/database.model";
import {UserinformationModel} from "../../models/userinformation.model";
import {LoginResponseModel} from "../../models/loginResponse.model";
import {SessionResponseModel} from "../../models/sessionResponse.model";
import {UserModel} from "../../models/user.model";
import {crc32} from "crc";

@Injectable()
export class LoginProvider {

  private credentials: { username: string, password: string } = null;
  private _isLoggedIn: boolean = false;
  private storageItems = ['user', 'database'];

  constructor(private globalProvider: GlobalProvider, private httpClient: HttpClient, private app: App) {
  }

  public login(username: string, password: string): Promise<LoginResponseModel> {

    return new Promise((resolve, reject) => {
      this.httpClient.post(this.globalProvider.remoteDatabaseURL + '/_session', {name: username, password: password}, {withCredentials: true})
        .subscribe((response: LoginResponseModel) => {
          resolve(response);
        }, (error) => {
          console.dir(error);
          reject({
            title: 'Fehler',
            message: 'Fehler beim einloggen. Bitte überprüfen Sie Ihre Zugangsdaten und versuchen Sie es erneut!'
          });
        })
    })
  }

  public isLoggedIn(): Promise<any> {

    return new Promise((resolve, reject) => {
      if(this.globalProvider.isBrowser()){
        //check is session is active

        this._checkSession()
          .then((success) => {

            if(this._isLocalStorageInformationsValid()){
              this._copyLocalStorageItemsToVariables();
              this.globalProvider.loggedIn.next(true);
              resolve();
            } else {
              reject();
            }

          }, () => {
            reject();
          })
      } else {
        // we are in app. check if we had following information in localStorage:
        // password

        if(!this._isLocalStorageInformationsValid() || localStorage.getItem('password') !== null){
          this._copyLocalStorageItemsToVariables();
          this.globalProvider.loggedIn.next(true);
          resolve();
        } else {
          reject();
        }
      }
    })



    // both need follow information in localStorage:
    // - username
    // - selectedDatabase
  }

  private _isLocalStorageInformationsValid(): boolean {
    for(let item of this.storageItems){

      const fieldValue = localStorage.getItem(item);
      const fieldValue2 = localStorage.getItem(item+'2');


      if(!fieldValue || fieldValue.length === 0 || !fieldValue2 || fieldValue2.length === 0){
        return false;
      } else {
        const fieldValueAsCRC32 = crc32(localStorage.getItem(item)).toString();
        if(!fieldValueAsCRC32 ||fieldValueAsCRC32.length === 0 || fieldValue2 !== fieldValueAsCRC32){
          return false;
        }
      }
    }
    return true;
  }

  private _checkSession(): Promise<boolean>{
    return new Promise((resolve, reject) => {
      this.httpClient.get(this.globalProvider.remoteDatabaseURL + '/_session', {withCredentials: true})
        .subscribe((response: SessionResponseModel) => {
          if(response.userCtx.name !== null){
            resolve(true);
          }
          else {
            reject();
          }
        })
    })

  }

  private _logOut() {
    this.app.getActiveNav().setRoot(HomePage);
  }

  private _copyLocalStorageItemsToVariables(){
    this.globalProvider.database = JSON.parse(localStorage.getItem('database'));
    this.globalProvider.user = JSON.parse(localStorage.getItem('user'));
  }

  public setLoggedIn(data: {user: UserModel, selectedDatabase: DatabaseModel}): void {

    // if(this.globalProvider.isBrowser()){
    this.globalProvider.database = data.selectedDatabase;
    this.globalProvider.user = data.user;

    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('user2', crc32(JSON.stringify(data.user)).toString())
    localStorage.setItem('database', JSON.stringify(data.selectedDatabase));
    localStorage.setItem('database2', crc32(JSON.stringify(data.selectedDatabase)).toString());

    this.globalProvider.loggedIn.next(true);

  }

  public setLoggedOut(message?: string) {

    for (let storageItemKey of this.storageItems) {
      localStorage.removeItem(storageItemKey);
      localStorage.removeItem(storageItemKey+'2');
    }

    this.globalProvider.database = null;
    this.globalProvider.user = null;
    this.globalProvider.loggedIn.next(false);

    this._isLoggedIn = false;
    this._logOut();
  }

  // public isLoggedIn(): Promise<any>{
  //   this.httpClient.get(this.globalProvider.remoteDatabaseURL+'/_session?basic=true')
  //     .subscribe((success) => {
  //       console.dir(success);
  //     }, (error) => {
  //       console.dir(error);
  //     })
  // }

  public getUserInformations(userName: string): Promise<UserinformationModel> {
    return new Promise((resolve, reject) => {
      this.httpClient.get(this.globalProvider.remoteDatabaseURL + '/_users/_design/teammembers/_show/teammembers/org.couchdb.user:' + userName, {withCredentials: true})
        .subscribe((response: UserinformationModel) => {
          if (response.hasOwnProperty('databases')) {
            resolve(response)
          } else {
            reject('User has no Databases');
          }
        }, () => {
          reject();
        })
    })

  }

  /*public setLoggedIn(username: string, password: string): boolean {

    if(this.globalProvider.isBrowser()){
      this.credentials = {username: username, password: password};
      return true;
    }
    else {
      this.secureStorage.create('cleverreport')
        .then((storage: SecureStorageObject) => {
          storage.set('username', username);
          storage.set('password', password);
          return true;
        })
    }
  }

  public setLoggedOut(options?: {message: string}): void {
    if(this.globalProvider.isBrowser()){
      this.credentials = null;
    }
    else {
      this.secureStorage.create('cleverreport')
        .then((storage: SecureStorageObject) => {
          storage.clear();
        })
    }

    //show login modal after logout
    let loginModal = this.modalCtrl.create(ModalNavPage, {page: LoginPage, param: {message: options.message}}, {enableBackdropDismiss: false});
    loginModal.present();


  }

  public isLoggedIn(): Promise<void> {
    return new Promise ((resolve, reject) => {
      this.getCredentials()
        .then(() => {
          resolve();
        }, () => {
          reject();
        })
    })
  }

  public getCredentials(): Promise<{username: string, password: string}> {
    if(this.globalProvider.isBrowser()){
      return new Promise((resolve, reject) => {
        if(this.credentials !== null){
          resolve(this.credentials);
        }
        else {
          reject();
        }
      })
    }
    else {
      this.secureStorage.create('cleverreport')
        .then((storage: SecureStorageObject) => {
          let usernamePromise = storage.get('username');
          let passwordPromsie = storage.get('password');

          return new Promise((resolve, reject) => {
            Promise.all([usernamePromise, passwordPromsie])
              .then((results) => {
                resolve({username: results[0], password: results[1]});
              }, () => {
                reject();
              })
          })
        })
    }
  }*/
}



// WEBPACK FOOTER //
// ./src/providers/login/login.provider.ts